import React, { useEffect, useState } from "react";
import { addOrUpdateBooking } from "../../../../../../APIs/Booking/UpdateBooking";
import { useDiaryContext } from "../../../../../../hooks/useDiaryContext";
import { EDSButton } from "../../../../../eds/EDSButton";
import { EDSQuantityStepper } from "../../../../../eds/EDSQuantityStepper";
import {
  getCheckInWaitlistProps,
  updateBooking
} from "../SelectedBookingManageController";

const CheckIn = () => {
  const diaryContext = useDiaryContext();
  const { selectedBooking, bookings, stages, setDiaryContext } = diaryContext;

  const arrived = (selectedBooking?.currentStage ?? "") !== "";
  const [guests, setGuests] = useState<number>(
    selectedBooking?.actualGuests ?? 1
  );

  useEffect(() => {
    setGuests(selectedBooking?.actualGuests ?? 1);
  }, [selectedBooking]);

  const handleToggleCheckIn = () => {
    if (!selectedBooking || !bookings) {
      return;
    }

    let stageId = "";
    let checkInWaitlistProps = {};
    if (!selectedBooking?.currentStage) {
      const arrivedStage = stages?.find(
        (stage) => stage.id.toLowerCase() === "arrived"
      );
      stageId = arrivedStage?.id ?? stages?.[0].id ?? "";
      checkInWaitlistProps = getCheckInWaitlistProps(selectedBooking);
    }

    const { updatedBookings, updatedBooking } = updateBooking({
      selectedBooking,
      bookings,
      bookingPropsToSave: {
        currentStage: stageId,
        actualGuests: guests,
        ...checkInWaitlistProps
      }
    });

    setDiaryContext({ bookings: updatedBookings });
    addOrUpdateBooking({
      booking: updatedBooking,
      diaryContext
    });
  };

  return (
    <div className="CheckIn pt-[var(--panelPadding)]">
      <div className="CheckIn-Title font-bold text-[length:var(--fontSize-base)]">
        Check In
      </div>
      <div className="CheckIn-GuestsContainer mt-[var(--panelPadding)] flex">
        {!arrived && (
          <div className="CheckIn-GuestsEdit flex items-center mr-[var(--panelPadding)]">
            <EDSQuantityStepper
              value={guests}
              onChange={setGuests}
              min={1}
              max={999}
              size="md"
            />
          </div>
        )}
        <EDSButton
          variant="default"
          size="md"
          className="checkIn-ToggleButton w-[130px]"
          disabled={!arrived && guests === 0}
          onClick={handleToggleCheckIn}
        >
          {arrived ? "Uncheck" : "Check In"}
        </EDSButton>
      </div>
    </div>
  );
};

export default CheckIn;
